/* Wardrobe advertorial sticky dock. Loaded only when wardrobe_variant is on.
   Shows after 1100px of scroll, hides while the closing offer box is in view. */
(() => {
  if (window.__oiWardrobeDockInitialized) return;
  window.__oiWardrobeDockInitialized = true;

  const THRESHOLD = 1100;
  const instances = new Map();

  const init = (root) => {
    if (!root || instances.has(root)) return;
    const dock = root.querySelector('.bottom-cta-dock');
    if (!dock) return;
    const offer = root.querySelector('.wardrobe-close') || root.querySelector('.wardrobe-close-copy');
    let offerInView = false;

    const update = () => {
      const visible = window.scrollY >= THRESHOLD && !offerInView;
      dock.classList.toggle('visible', visible);
      dock.setAttribute('aria-hidden', visible ? 'false' : 'true');
      dock.querySelectorAll('a').forEach((link) => {
        if (visible) link.removeAttribute('tabindex');
        else link.setAttribute('tabindex', '-1');
      });
    };

    let observer = null;
    if (offer && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => { offerInView = entry.isIntersecting; });
        update();
      }, { threshold: 0.1 });
      observer.observe(offer);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    instances.set(root, () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
      if (observer) observer.disconnect();
    });
    update();
  };

  const destroy = (root) => {
    const cleanup = instances.get(root);
    if (cleanup) cleanup();
    instances.delete(root);
  };

  const initWithin = (scope) => {
    if (!scope) return;
    if (scope.matches && scope.matches('.oi-wardrobe-page')) init(scope);
    scope.querySelectorAll('.oi-wardrobe-page').forEach(init);
  };

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    instances.forEach((_, root) => {
      if (event.target.contains(root)) destroy(root);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
  } else {
    initWithin(document);
  }
})();
